import { Directive } from '@angular/core';
import {
   LcsChipMultiSelectTextContentFn,
   LcsChipMultiSelectTriggerComponent,
} from 'src/app/common-components/multi-select/chip-multi-select-trigger.component';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';

@Directive({
    selector: 'lcs-chip-multi-select-trigger[ndtRoleMultiSelect]',
    standalone: false
})
export class RoleChipMultiSelectTriggerDirective {
   constructor(trigger: LcsChipMultiSelectTriggerComponent<RoleOption>) {
      trigger.getDisplayText = entityChipMultiSelectText(trigger);
   }
}

export function entityChipMultiSelectText<T = RoleOption>(
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   _multiSelect: LcsChipMultiSelectTriggerComponent<RoleOption>
): LcsChipMultiSelectTextContentFn<RoleOption> {
   return (item: RoleOption | null | undefined): string => {
      return `${item?.name}`;
   };
}
